import 'react';
import { TextInputField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import '../../../components/Canvas/Canvas.style.js';
import '../../../components/Canvas/PreviewModeContainer.js';
import '../../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../../components/FieldItem.js';
import '../../../components/FormGroup/FormGroup.js';
import '../../../components/FormGroup/LogDataFormGroup.js';
import '../../../components/Header/index.js';
import '../../../components/Input/ColorPickerField/index.js';
import '../../../components/Input/URLInput.js';
import '../../../components/Inspector/Inspector.js';
import '../../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../../components/Tooltip/Tooltip.js';
import '../../../components/Toolbar/Toolbar.style.js';
import '../../../components/TreeList/Draggable.js';
import '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../../components/FormContent.js';
import { InspectorFormProvider } from '../../../components/InspectorFormProvider.js';

function AnchorTargetInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(FormContent, {
    header: "\uC575\uCEE4 \uD0C0\uAC9F id"
  }, jsx(TextInputField, {
    name: "targetId",
    width: "100%"
  })));
}

export { AnchorTargetInspector };
//# sourceMappingURL=AnchorTarget.Inspector.js.map
